import {Button, Col} from "react-bootstrap";
import React, {useRef, useState} from "react";
import {RequireAuth} from "../../Components/Security/RequireAuth";
import {DefaultContainer} from "../Shared/DefaultContainer";
import {useMutation, useQuery} from "react-query";
import {getFinanceExpensesList, resumeExport} from "../../Api/Query/Finance";
import {LocalStorage} from "../../Services/LocalStorage/LocalStorage";
import {AdminCrudList} from "../Shared/Crud/AdminCrudList";
import {forceDownloadFromUrl} from "../../Services/File/FileDownloader";
import {removeFinanceResumeItems} from "../../Api/Mutation/Finance";

export const FinanceView: React.FC = () => {
    const localStorage = new LocalStorage()
    const PAGE_FILTER = 'admin.expenses_list.page'
    const page = useRef<number>(localStorage.get(PAGE_FILTER) ? parseInt(localStorage.get(PAGE_FILTER)) : 1)

    const [refreshSwitch, setRefreshSwitch] = useState<boolean>(false)
    const exportYear = useRef(null)
    const exportMonth = useRef(null)

    const [exportingExpenseId, setExportingExpenseId] = useState<number>(-1)
    const [deletingExpenseId, setDeletingExpenseId] = useState<number>(-1)

    const expensesExportQuery = useQuery({
        enabled: false,
        queryKey: ['financeExpensesExport'],
        queryFn: () => resumeExport(exportMonth?.current ?? -1, exportYear?.current ?? -1),
        onSuccess: (response: any) => {
            const data = response?.data?._result ?? []
            const url = data?.url ?? ''

            if(url){
                forceDownloadFromUrl(url)
            }

            exportYear.current = null
            exportMonth.current = null
            setExportingExpenseId(-1)
        },
    })

    const removeMutation = useMutation({
        mutationFn: (item: any) => removeFinanceResumeItems(item.month, item.year),
        onSuccess: () => {
            setRefreshSwitch(!refreshSwitch)
            setDeletingExpenseId(-1)
        }
    })

    const exportExpenses = (item: any, key: number) => {
        setExportingExpenseId(key)
        exportMonth.current = item.month
        exportYear.current = item.year
        expensesExportQuery.refetch()
    }

    return (
        <RequireAuth>
            <DefaultContainer>
                <Col id={"mainRequestList"}>

                    <AdminCrudList
                        defaultPage={page.current}
                        onPageChange={(newPage:number) => {
                            page.current = newPage
                        }}
                        id={"expensesList"}
                        title={"Listado de gastos"}
                        headers={['Mes', 'Año', 'Importe total','']}
                        queryMethod={getFinanceExpensesList}
                        queryName={"financeRevenueList"}
                        refreshSwitch={refreshSwitch}
                        deleteMethod={()=>{}}
                        canSelectMultipleRows={false}
                        tableRow={(item: any, key: number) =>
                            <>
                                <td>{item.month}</td>
                                <td>{item.year}</td>
                                <td>{item.totalAmount} €</td>
                                <td width={"20%"}>
                                    <Button
                                        className={"purple-btn btn-sm"}
                                        onClick={() => exportExpenses(item, key)}
                                        disabled={key === exportingExpenseId}
                                    >
                                        {exportingExpenseId === key ? 'Exportando ...' : 'Exportar'}
                                    </Button>
                                    &nbsp;
                                    <Button
                                        className={"purple-btn btn-sm"}
                                        disabled={key === deletingExpenseId}
                                        onClick={() => {

                                            if(!window.confirm('¿Deseas eliminar los gastos de este mes?')) {
                                                return
                                            }

                                            setDeletingExpenseId(key)
                                            removeMutation.mutate({
                                                month: item.month,
                                                year: item.year
                                            })
                                        }}
                                    >
                                        {key === deletingExpenseId ? 'Eliminando ...' : 'Eliminar'}
                                    </Button>
                                </td>
                            </>
                        }
                    />

                </Col>
            </DefaultContainer>
        </RequireAuth>
    )
}

